import React from 'react'
export default function MinimalDownIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M8 12.6.3 4.9l1.4-1.5L8 9.7l6.3-6.3 1.4 1.5z"/></g></svg>)
}
